import { graphql } from 'gatsby';
import React from 'react';

import { Drupal_ParagraphNineteenTextCta } from '../../../generated/graphql';
import NineteenCta, { nineteenCtaThemes } from '../nineteen-cta/nineteen-cta';
import './nineteen-text-cta.scss';

interface Props {
  entity: Drupal_ParagraphNineteenTextCta;
}

const NineteenTextCta = ({
  entity: { fieldHeading, fieldSingleCta }
}: Props) => (
  <section className="nineteen-text-cta">
    <div className="lucid-container nineteen-text-cta__wrapper">
      <h1 className="nineteen-text-cta__header">{fieldHeading}</h1>
      <div className="nineteen-text-cta__link">
        {fieldSingleCta && (
          <NineteenCta
            primary
            entity={fieldSingleCta.entity!}
            theme={nineteenCtaThemes.inverse}
          />
        )}
      </div>
    </div>
  </section>
);

export default NineteenTextCta;

export const query = graphql`
  fragment nineteenTextCta on Drupal_ParagraphNineteenTextCta {
    entityId
    fieldHeading
    fieldSingleCta {
      entity {
        ...nineteenCta
      }
    }
  }
`;
